module.exports = __webpack_public_path__ + "img/img161.01e1dc5b.png";